import React, { useEffect, useState, } from "react";
import DynamicField from "./DynamicFields";
import customizeformApi from "../../api/customizeformApi";
import { toast } from "react-toastify";

function CustomizeForm() {
    const formId = "6a868d4bde35f4dbf90a9701";

    const [formData, setFormData] = useState({});
    const [formSchema, setFormSchema] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchForm();
    }, []);

    const fetchForm = async () => {
        try {
            const response = await customizeformApi.customize({ formId });
            // console.log("API Response",response.data);
            setFormSchema(response.data);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    // console.log("formSchema =>", formSchema);
    const handleChange = (key, value) => {
        setFormData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                answers: formData
            };
            const response = await customizeformApi.createSubmission(formId, payload);
            console.log("Submission Success", response.data);
              toast.success(
            "Your form has been submitted successfully!"
        );

            setFormData({})
        } catch (error) {
            console.log("Submission Error", error.response?.data);
             toast.error(
            error.response?.data?.message ||
            "Failed to submit form"
        );
        }
    };

    if (loading) {
        return (
            <div className="text-center py-5">
                Loading Form...
            </div>
        );
    }

    return (
        <div className="custom-ax-customize-cake-sec-wrapper">
            <div className="custom-ax-customize-cake-sec-card">
                <h2 className="custom-ax-customize-cake-sec-title">
                    {formSchema?.name}
                </h2>
                <form
                    onSubmit={handleSubmit}
                    className="custom-ax-customize-cake-sec-form  mt-3">
                    <div className="row">
                        {formSchema?.fields?.map(
                            (field) => (
                                <div
                                    key={field.key}
                                    className={
                                        field.type === "textarea"
                                            ? "col-12 "
                                            : field.type === "image"
                                                ? "col-md-6    col-12"
                                                : "col-md-6   col-12"
                                    }
                                >
                                    <div className="custom-ax-customize-cake-sec-group">
                                        <label>
                                            {field.label}

                                            {field.required &&
                                                " *"}
                                        </label>

                                        <DynamicField
                                            field={field}
                                            value={
                                                formData[
                                                field.key
                                                ]
                                            }
                                            onChange={
                                                handleChange
                                            }
                                        />
                                    </div>
                                </div>
                            )
                        )}
                    </div>
                    <button
                        type="submit"
                        className="custom-ax-customize-cake-sec-btn">
                        Submit
                    </button>
                </form>
            </div>
        </div>
    );
}

export default CustomizeForm;